import Button from "./Button";
import styled from "styled-components/macro";

const ActiveButton = styled(Button)`
  background: ${(props) => props.theme.colors.primary};
  border: 1px solid ${(props) => props.theme.colors.primary};
`;

export default ActiveButton;
